import { render } from "./HoursView.vue?vue&type=template&id=ecea9956"
import script from "./HoursView.vue?vue&type=script&lang=js"
export * from "./HoursView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__